module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/fac-step5-67c3fa12c59d9bc1115217bb44d71532.svg";